<button
    [disabled]="_widgetLinks.length === 0"
    (click)="onMenuOpened(); actionButtonsMenu.toggle($event);"
    pButton
    pRipple
    type="button"
    icon="mi mi-button-more"
    class="p-button-secondary p-button-rounded p-button-text">
</button>

<p-menu #actionButtonsMenu [popup]="true" [model]="actions" appendTo="body"></p-menu>
